import React, { memo } from "react";

import Button from "./Button";
import { Link } from "react-router-dom";

const SubHeading = ({
  subTitle = "",
  isAddBtn = true,
  handleShowHide,
  isImportBtn = false,
  isAddBtnPage = false,
  redirectPath = "",
  isDynamicBtn = false,
  dynamicBtnName = "",
  onClick,
  createAccess = false,
  updateAccess = false,
  isRestartService = false,
}) => {
  return (
    <>
      <div className="card-header my-1">
        <div className="row align-items-center m-0 p-0">
          <div className="col-auto m-0 p-0">
            <h4 className="card-title">{subTitle}</h4>
          </div>

          <div className="col-auto ms-auto m-0 p-0 d-flex">
            {isImportBtn && (
              <Button
                icon="FaPlus"
                className="btn btn-primary m-1 btn_add"
                onClick={() => handleShowHide("import")}
              >
                Import
              </Button>
            )}

            {isAddBtn && createAccess && (
              <Button
                icon="FaPlus"
                className="btn btn-primary m-1 btn_add"
                onClick={() => handleShowHide("add")}
              >
                Add
              </Button>
            )}

            {isAddBtnPage && createAccess && (
              <Button icon="FaPlus" className="btn btn-primary m-1 btn_add">
                <Link to={redirectPath}>Add link</Link>
              </Button>
            )}

            {isDynamicBtn && updateAccess && (
              <Button className="btn btn-primary m-1 btn_add" onClick={onClick}>
                {dynamicBtnName}
              </Button>
            )}

            {isRestartService && (
              <Button className="btn btn-primary m-1" onClick={onClick}>
                Restart
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(SubHeading);
